import { render } from "./HomeExamPaper.vue?vue&type=template&id=057f4471&scoped=true"
import script from "./HomeExamPaper.vue?vue&type=script&lang=js"
export * from "./HomeExamPaper.vue?vue&type=script&lang=js"

import "./HomeExamPaper.vue?vue&type=style&index=0&id=057f4471&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057f4471"]])

export default __exports__